// extracted by mini-css-extract-plugin
export default {"list":"List_list__Uh3RE","list--mobile":"List_list--mobile__OdWRw"};